import {LANDING_SLUGS} from './registry';

/** Comma-separated hosts whose whole path space belongs to the landings. */
const LANDINGS_HOSTS = (
  import.meta.env.VITE_LANDINGS_HOST as string | undefined
)
  ?.split(',')
  .map((host) => host.trim().toLowerCase())
  .filter(Boolean);

const normalizePath = (pathname: string) => {
  const trimmed = pathname.replace(/\/+$/, '').toLowerCase();
  return trimmed === '' ? '/' : trimmed;
};

export const isLandingsHost = (host: string) =>
  Boolean(LANDINGS_HOSTS?.includes(host.toLowerCase()));

/** True only for a path registered in the landings registry. */
export const isLandingPath = (pathname: string) => {
  const path = normalizePath(pathname);
  return LANDING_SLUGS.some((slug) => path === `/${slug}`);
};

/**
 * On the landings host every path is a landing, so unknown ones can 404 there.
 * On the app host only registered slugs divert, leaving the app untouched.
 */
export const shouldRenderLandings = ({
  host,
  pathname,
}: {
  host: string;
  pathname: string;
}) => isLandingsHost(host) || isLandingPath(pathname);
